module.exports = __webpack_public_path__ + "img/pv-02.3b0d9dc5.svg";